import { useMemo } from "react";
import { mergeClasses } from "@fluentui/react-components";
import { MILESTONE_DELIVERABLE_STATUS_TONE } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.constants";
import { dashboardTokens } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.tokens";
import {
  IMilestonesLogTableProps,
  IReadOnlyTableColumn,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";
import {
  getPillToneClassName,
  useGroupedWorkspaceDashboardStyles,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { LogEmptyState } from "apps/project-iq/components/GroupedWorkspaceDashboard/LogEmptyState";
import { ReadOnlyLogTable } from "apps/project-iq/components/GroupedWorkspaceDashboard/ReadOnlyLogTable";
import { IMilestone } from "apps/project-iq/components/WorkspacePlan/WorkspacePlan.types";
import { formatDate } from "apps/project-iq/utils/workspaceOverviewUtils";

export const MilestonesLogTable = ({
  milestones,
}: IMilestonesLogTableProps): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();

  const columns: IReadOnlyTableColumn<IMilestone>[] = useMemo(
    () => [
      {
        columnKey: "name",
        header: "Name",
        renderCell: (item) => (
          <span className={styles.logPanelNameMilestone}>{item.name}</span>
        ),
      },
      {
        columnKey: "dueDate",
        header: "Due Date",
        renderCell: (item) => (
          <span className={styles.logPanelCellMuted}>
            {item.dueDate ? formatDate(item.dueDate) : "—"}
          </span>
        ),
      },
      {
        columnKey: "status",
        header: "Status",
        renderCell: (item) => {
          const tone = MILESTONE_DELIVERABLE_STATUS_TONE[item.status];
          return (
            <span
              className={mergeClasses(
                styles.pill,
                getPillToneClassName(styles, tone?.toneKey),
              )}
            >
              {tone?.label}
            </span>
          );
        },
      },
    ],
    [styles],
  );

  return (
    <ReadOnlyLogTable<IMilestone>
      items={milestones}
      columns={columns}
      getRowId={(item) => item.id}
      ariaLabel="Milestones"
      gridTemplateColumns={dashboardTokens.grid.milestones}
      emptyState={<LogEmptyState logTab="milestones" />}
    />
  );
};
